<template>
  <footer class="footer">
    <div class="footer--inner py-3xl">

      <!-- main site footer links placeholder -->
      <div class="footer--inner__bottom">
        <div class="footer--inner__bottom__left font-bd">
          <router-link class="logo-wrap" :to="`${parsedLocaleString}/`">
            <!-- <logo /> -->
            <img src="img/mis-ds-logo.png" />
          </router-link>
          <div class="creds-wrap">
            <span class="creds fs12">
                MIS IMPLANTS TECHNOLOGIES LTD. 2024.
                <br/>
                ALL RIGHTS RESERVED
              </span>
          </div>
        </div>
        <div class="footer--inner__bottom__right">
          <a
            target="_blank"
            class="social-link"
            href="https://www.facebook.com/MisImplantsTechnologiesLtdGlobal"
          >
            <i class="fab fa-facebook-f" />
          </a>
          <a
            target="_blank"
            class="social-link"
            href="https://twitter.com/MISimplantsGlob"
          >
            <i class="fab fa-twitter" />
          </a>
          <a
            target="_blank"
            class="social-link"
            href="https://www.instagram.com/mis_implants_ltd_global"
          >
            <i class="fab fa-instagram" />
          </a>
          <a
            target="_blank"
            class="social-link"
            href="https://www.linkedin.com/company/mis-implants-technologies-ltd-"
          >
            <i class="fab fa-linkedin-in" />
          </a>
          <a
            target="_blank"
            class="social-link"
            href="https://www.youtube.com/misimplantsltd"
          >
            <i class="fab fa-youtube" />
          </a>
          <a
            target="_blank"
            class="social-link"
            href="https://vimeo.com/misimplants"
          >
            <i class="fab fa-vimeo-v" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { subdomain } from "@/utils";
export default {
  computed: {
    ...mapState(["menuItems", "locale"]),
    ...mapGetters(["localeString"]),
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    }
  },
  methods: {
    showFooterLinks()
    {
      var _subdomain = subdomain();
      if(!_subdomain){
        return true;
      }
      return _subdomain == "patient" || _subdomain=="lab"  ? false : true;
    },
    parseFooterClass(title) {
      return `footer-${title
        .toLowerCase()
        .split(" ")
        .join("-")}`;
    },
    sortedChildren(children) {
      // children = _.filter(
      //   children,
      //   child => child.path.indexOf("booklets") < 0
      // );
      return _.sortBy(children, "sort");
    }
  }
};
</script>

<style scoped>
  .footer--inner__bottom__right a:nth-child(1)
  {
    margin-left: 0px;
  }
  .creds-wrap
  {
    width: 100%;
  }
</style>
<style lang="stylus">

.social-link
  +above(680px)
    border-radius 100%
    padding 2px
    i
      transition box-shadow 0.3s ease-out, transform 0.3s ease-out
      color #fff
    +desktop()
      &:hover
        box-shadow 0 0 12px rgba(#fff,0.5), inset 0 0 24px rgba(#fff,0.21)
        i
          color #fff
          display block
          transform translateY(-2px)
          border-radius 100%
          padding 2%

.footer
	background c_dk_blue
	width 100%
	&--inner
		width 90vw
		margin 0 auto
		&__bottom
			_flex(column,wrap,flex-start,flex-start)
			+above(600px)
				_flex(row,wrap,center,space-between)
			&__right
				flex 1
				_flex(row,wrap,center,flex-end)
				.language-link
					_flex(row,wrap,center,center)
					flex-wrap nowrap
					background lighten(c_dk_blue, 5)
					padding 5px 5px 5px
					line-height 1
					border-radius 3px
					min-width 130px
					img, i
						display inline-block
						vertical-align middle
						max-width 16px
						opacity 0.6
						margin 0 5px
					span
						color #fff
						flex 0 0 80%
						--font-size 12px
          i
						mix-blend-mode luminosity
				a.social-link        
					margin-left 15px
					color #fff
			&__left
        _flex(row,wrap,center,flex-start)
        padding-top 0px
        width 100%
        flex 1
        +below(600px)
          padding-top 0
          .creds-wrap
            //_flex(row,wrap,center,flex-start)
            height 30px
				+above(415px)
					width auto
					margin-top 0
					_flex(row,wrap,center,flex-start)
				& > *
					flex 1
				.logo-wrap          
          img
            height 45px
            width auto
						margin-right 20px            
            +above(400px)
              height 30px
              width auto
					max-width 60px
					margin-right 8px
					+above(400px)
            padding-bottom 5px
						max-width 80px
						margin-right 20px
					svg
						fill #fff
						max-width 100%
				span
					display block
					text-align left
					font-size 10.5px
					+above(400px)
						--font-size 12px
					&.creds
						color #6ba1c1
						margin-top 5px
            font-weight 300 !important
						+above(415px)
              padding-top: 5px;
							margin-bottom 0px
					&.links
						&.mobile
							flex 0 0 100%
							font-size 12px
							margin 15px 0
						a
							color #fff
							margin-right 10px
							opacity 0.9
							display inline-block
              font-weight 300 !important
							hoverize(1, opacity)

		&__top
      _flex(row,wrap,flex-start,space-between)
      border-bottom 1px solid c_md_blue
      +below(1100px)
        column-count 3
        column-gap 5%
        display block
      +below(815px)
        column-count 2
      +below(600px)
        column-count 1
		&--category
      min-height 50px
      text-align left
      margin-bottom 30px
      flex 0 0 45%
      break-inside avoid
      page-break-inside avoid
      +above(1100px)
        margin-right 3%
        flex 1
      +below(600px)
        margin-bottom 10px
        &:last-child
          margin-bottom 0
			h4
        width 100%
        font-size responsive 14px 18px
        font-range 1366px 1920px
        margin 0 0 25px 0
        padding 0 0 15px
        border-bottom 1px solid c_md_blue
        height 50px
        _flex(column, nowrap, flex-start, flex-end)

        a
          color c_txt_blue
          +desktop()
            &:hover
              color lighten(c_txt_blue, 10)
        +below(600px)
          height auto
          margin-bottom 15px
          padding-botom 5px
		&--subcategory
			padding-bottom 5px
			/.footer-products &
				flex 0 0 48%
			h5
				margin 0
				padding 0 0 10px
				a
					font-weight 200
					color #fff
					font-size 13px
			& > a
        display block
        color gray_4 !important
        font-size 13px
        margin-bottom 10px
        +desktop()
          &:hover
            color #fff !important
.page.has-media + .footer
	+below(815px)
		margin-top 0
.home + .footer
	margin-top 1px
.dashboard + .footer
  display none

.language-link
  transition background 0.2s ease-out, box-shadow 0.2s ease-out
  +desktop()
    &:hover
      box-shadow 0 0 12px rgba(#fff, 0.3)
</style>
